import cx from 'classnames'

import Styles from './Properties.module.scss'

import { Button } from 'components/Button/Button'
import PropertyIcon from 'common/PropertyItem/PropertyIcon'
import { ReactComponent as ShownIcon } from 'assets/icons/eye16.svg'
import { ReactComponent as HiddenIcon } from 'assets/icons/eyeClosed16.svg'
import { ReactComponent as CaretRight } from 'screens/Finder/components/ViewPreferences/components/Preferences/icons/chevron-right.svg'

import { useFinderContext } from 'screens/Finder/FinderContext'

import { VisiblePadOptions, PropertyVisibility, EditableProperty, findEditComponent } from './Properties'
import { SetState } from 'types'
import { Property, PropertyType } from 'api/clients/PropertyClient'
import { isCalendarProperty } from 'screens/Finder/components/views/CalendarView/utils'

type Props = {
  property: Property
  visibility: PropertyVisibility
  setVisiblePad: SetState<VisiblePadOptions>
  setEditableProperty: SetState<EditableProperty | undefined>
  isDisabled?: boolean
}

export const PropertyRow = ({
  property,
  visibility,
  setEditableProperty,
  setVisiblePad,
  isDisabled = false,
}: Props) => {
  const { filesView, removePropertyFromSchema, addPropertyToSchema } = useFinderContext()

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const workflowProperty = filesView?.schema!.workflow_property

  const buttonData = {
    [PropertyVisibility.Shown]: {
      icon: <ShownIcon className={cx(Styles.iconNoMargin, Styles.visibleIcon)} data-testid="shown-button" />,
      onIconPress: () => removePropertyFromSchema(property.id),
    },
    [PropertyVisibility.Hidden]: {
      icon: <HiddenIcon className={cx(Styles.iconNoMargin, Styles.hiddenIcon)} data-testid="hidden-button" />,
      onIconPress: () => addPropertyToSchema(property),
    },
  }
  const { icon, onIconPress } = buttonData[visibility]

  const editProperty = () => {
    setEditableProperty({ property, visibility })
    setVisiblePad(findEditComponent({ property, workflowProperty }))
  }

  return (
    <div
      className={cx(Styles.flexContainer, Styles.spaceBetween, Styles.rowHover)}
      data-testid="property-row-container"
    >
      <Button
        className={cx(Styles.flexContainer, Styles.flexGrow, Styles.resetHover, Styles.columnGap0, Styles.padding8)}
        variant="tertiary"
        size="lg"
        onPress={editProperty}
        isDisabled={isDisabled}
      >
        <PropertyIcon type={property.type} defaultType={property.default_type} />
        <div className={Styles.label} data-testid="property-row-name">
          {property.name}
        </div>
      </Button>
      <div className={cx(Styles.flexContainer, Styles.icon)}>
        {property.type !== PropertyType.Title && !isCalendarProperty({ filesView, propertyId: property?.id }) && (
          <Button
            className={cx(Styles.padding8, Styles.minHeight32)}
            variant="tertiary"
            size="lg"
            isDisabled={isDisabled}
            onPress={onIconPress}
            data-testid="property-row-visibility-btn"
          >
            {icon}
          </Button>
        )}
        <Button
          className={cx(Styles.padding8, Styles.resetHover, Styles.oldSvgGrey40)}
          variant="tertiary"
          size="lg"
          onPress={editProperty}
          isDisabled={isDisabled}
        >
          <CaretRight />
        </Button>
      </div>
    </div>
  )
}
